import { Component, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AGENDA_KIND, AgendaEvent } from '../agenda-types';

/** Detalle de un evento de la Agenda con acceso directo a su módulo. */
@Component({
  selector: 'app-agenda-event-dialog',
  standalone: true,
  imports: [DatePipe, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
<div class="ev-head" [style.--kind]="meta.color">
  <span class="ev-head__icon"><mat-icon>{{ meta.icon }}</mat-icon></span>
  <div class="ev-head__text">
    <small>{{ meta.singular }}</small>
    <b>{{ ev.title }}</b>
  </div>
  @if (ev.status) { <span class="ev-status">{{ ev.status }}</span> }
</div>
<mat-dialog-content>
  <div class="ev-when"><mat-icon>event</mat-icon>{{ ev.date | date:(ev.hasTime ? "EEEE d 'de' MMMM yyyy, HH:mm" : "EEEE d 'de' MMMM yyyy"):'':'es' }}</div>
  <dl class="ev-fields">
    @for (d of ev.details; track d.label) {
      @if (d.value) { <dt>{{ d.label }}</dt><dd>{{ d.value }}</dd> }
    }
  </dl>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Cerrar</button>
  <button mat-flat-button color="primary" (click)="open()"><mat-icon>open_in_new</mat-icon> Abrir {{ meta.singular.toLowerCase() }}</button>
</mat-dialog-actions>`,
  styles: [`
    .ev-head { display: flex; align-items: center; gap: 12px; padding: 20px 24px 8px; }
    .ev-head__icon { display: grid; place-items: center; width: 42px; height: 42px; border-radius: 12px;
      background: color-mix(in srgb, var(--kind) 12%, white); color: var(--kind); }
    .ev-head__text { display: flex; flex-direction: column; flex: 1 1 auto; min-width: 0;
      small { color: #6b7280; text-transform: uppercase; letter-spacing: .4px; font-size: 11px; }
      b { font-size: 18px; color: #170f5f; word-break: break-word; } }
    .ev-status { font-size: .72rem; font-weight: 700; padding: 3px 10px; border-radius: 999px; text-transform: uppercase;
      background: #f4f4f4; color: #555; }
    .ev-when { display: flex; align-items: center; gap: 8px; color: #374151; margin-bottom: 12px; text-transform: capitalize;
      mat-icon { color: #6b7280; } }
    .ev-fields { display: grid; grid-template-columns: max-content 1fr; gap: 6px 16px; margin: 0; font-size: 14px;
      dt { color: #6b7280; font-weight: 500; } dd { margin: 0; color: #1f2937; word-break: break-word; } }
  `],
})
export class AgendaEventDialogComponent {
  get meta() { return AGENDA_KIND[this.ev.kind]; }
  constructor(
    @Inject(MAT_DIALOG_DATA) public ev: AgendaEvent,
    private readonly ref: MatDialogRef<AgendaEventDialogComponent>,
    private readonly router: Router,
  ) {}
  open(): void {
    this.ref.close();
    void this.router.navigate(this.ev.link);
  }
}
